module.exports = __webpack_public_path__ + "media/images/glyphicons-halflings-green-9d12c34cf228cc3719da4497b8eec652.png";